import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { BaseClass } from '../../shared/classes/base';
import { Router } from '@angular/router';
import { AbstractControl } from '@angular/forms';
import { FrozenStructure } from '../_interfaces/frozen-structure';
import { UsersSyncErrorDialogComponent } from './users-sync-error-dialog/users-sync-error.dialog';
import { UsersService } from '../users.service';
import { UserSyncPreview } from '../_interfaces/sync-preview';
import { ModalController, ToastController } from '@ionic/angular';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { Evaluation360Service } from 'src/app/360-evaluation/360-evaluation.service';
import { SelfEvaluationService } from 'src/app/self-evaluation/self-evaluation.service';
import { ManagerEvaluationService } from 'src/app/manager-evaluation/manager-evaluation.service';
import { FrozenStructureModalComponent } from 'src/app/users/users-sync/frozen-structure-modal/frozen-structure.modal';
import { ConfigService } from 'src/app/shared/services/multi-clients/config.service';

@Component({
    selector: 'app-settings-users-sync',
    templateUrl: './users-sync.component.html',
    styleUrls: ['./users-sync.component.scss']
})
export class SettingsUsersSyncComponent extends BaseClass implements OnInit {
    public frozenStructureEnabled: boolean;

    public readonly pageSize: number = 10;
    public readonly displayedColumns: string[] = [
        'status', 'date', 'hour', 'usersCount', 'newUsersCount', 'updatedUsers', 'blockedUsers', 'actions'
    ];
    public processes: Array<UserSyncPreview> = [];
    public processesCount: number = 0;
    public frozenStructure: FrozenStructure = null;

    private _processesPage: number = 1;

    constructor(
            protected _toastController: ToastController,
            protected _translationService: TranslationService,
            private _usersService: UsersService,
            private _router: Router,
            private _dialog: MatDialog,
            private _360Service: Evaluation360Service,
            private _selfEvalService: SelfEvaluationService,
            private _modalController: ModalController,
            private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
        this.frozenStructureEnabled = this._configService.settings.features.frozenStructureEnabled;
        this.frozenStructure = {
            Enabled: false,
            StartDate: "",
            EndDate: "",
            TotalFreezingStartDate: "",
            TotalFreezingEndDate: "",
        };
        this._loadProcesses(this._processesPage);
    }

    public goToPage(page: number) {
        if (page !== this._processesPage) {
            this._processesPage = page;
            this._loadProcesses(this._processesPage);
        }
    }

    public viewDetails(process: UserSyncPreview) {
        if (process) {
            localStorage.setItem('SyncProcess', JSON.stringify(process));
            this._router.navigate(['usuarios/processo-de-sincronia/' + process.id]);
        }
    }

    public openErrorsDialog(process: UserSyncPreview) {
        this._dialog.open(UsersSyncErrorDialogComponent, {
            width: '1000px',
            data: process.importErrors
        });
    }

    private _loadProcesses(page: number): void {
        this._usersService.getPagedFilteredUsersSyncProcesses(
                page, this.pageSize
        ).subscribe((response) => {
            this.processes = response.data.userSyncProcessItems;
            this.processesCount = response.data.itemsCount;
            if(response.data.frozenStructure)
                this.frozenStructure = response.data.frozenStructure;

        }, (error) => this.notify(this.getErrorNotification(error), 'danger'));
    }

    public setDocumentFile(files: FileList) {
        const file = files.item(0);
        const callback = this._sendToServer.bind(this);
        const reader = new FileReader();
        reader.onloadend = function (e) {
            callback(
                    this.result as string,
                    file.name,
                    file.name,
                    file.name
            );
        };
        reader.readAsDataURL(file);
    }

    private async _sendToServer(result: string, fileName: string, valueControl: AbstractControl, nameControl: AbstractControl) {
        const resource = {
            'fileContent': result
        };
        await this.notify('Dependendo do tamanho da planilha o processo de importação pode demorar\num pouco. Assim que completar ele aparecerá na lista abaixo');

        await this._usersService.postUsersSyncProcess(resource).subscribe(async (response) => {
            await this.notify('Arquivo enviado com sucesso!', 'success');

            this._loadProcesses(this._processesPage);
        }, async (err) => {
            await this.notify(this.getErrorNotification(err), 'danger');
        });
    }

    public sendLastDayEmail() {
        this._360Service.sendLastDayEmail(1, true, true).subscribe((response) => {
            this.notify('Emails 360 Enviados', 'success');

            this._selfEvalService.sendLastDayEmail(1, true, true).subscribe((response2) => {
                this.notify('Emails Self Enviados', 'success');

            }, (error) => this.notify(this.getErrorNotification(error), 'danger'));

        }, (error) => this.notify(this.getErrorNotification(error), 'danger'));
    }

    public async openFrozenStructureDialog() {
        const modal = await this._modalController.create({
            component: FrozenStructureModalComponent,
            cssClass: 'frozen-structure',
            componentProps: {},
        });

        modal.onDidDismiss().then((dismissEvent) => {
            if (dismissEvent.data) {
            }
        });

        return await modal.present();

    }
}
